<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('couponList.type')" prop="type">
          <el-select v-model="ruleForm.type" :placeholder="$t('please_select')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('couponList.time')" prop="start_time">
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :range-separator="$t('to')"
            :start-placeholder="$t('start_date')"
            :end-placeholder="$t('end_date')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('couponList.title')" prop="title">
          <el-input
            maxlength="15"
            show-word-limit
            v-model="ruleForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('couponList.amount')" prop="amount">
          <el-input
            @input="
              (res) => {
                this.ruleForm.amount = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            :value="ruleForm.amount"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('activityList.total_num')" prop="total_num">
          <el-input
            @input="
              (res) => {
                this.ruleForm.total_num = +res;
              }
            "
            @mousewheel.native.prevent
            @DOMMouseScroll.native.prevent
            type="number"
            :value="ruleForm.total_num"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!noId" :label="$t('couponList.setMember')" prop="go_set_member">
          <el-button type="default" @click="handleSetMember">{{ $t('couponList.setMemberBtn') }}</el-button>
          <p class="setMemberNum"><span class="asterisk">*</span> 현재 선택된 대상 회원 : {{ ruleForm.redeem_num || 0 }}</p>
        </el-form-item>
        <!-- <el-form-item :label="$t('couponList.redeem_code')" prop="redeem_code">
          <el-input
            @input="
              (res) => {
                this.ruleForm.redeem_code = +res;
              }
            "
            @mousewheel.native.prevent  
            @DOMMouseScroll.native.prevent 
            type="number"
            :value="ruleForm.redeem_code"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t('btnTip.submit')
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat';
import { couponDetail, addCoupon, editCoupon } from '@/api/api';
export default {
  name: 'editCoupon',
  data() {
    return {
      time,
      ruleForm: {
        type: '',
        start_time: '',
        end_time: '',
        title: '',
        amount: '',
        total_num: '',
      },
      rules: {
        type: [
          {
            required: true,
            message: this.$t('couponList').type,
            trigger: 'blur',
          },
        ],
        start_time: [
          {
            required: true,
            message: this.$t('couponList').time,
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: this.$t('couponList').title,
            trigger: 'blur',
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t('couponList').amount,
            trigger: 'blur',
          },
        ],
        total_num: [
          {
            required: true,
            message: this.$t('activityList').total_num,
            trigger: 'blur',
          },
        ],
        // redeem_code: [
        //   {
        //     required: true,
        //     message: this.$t("couponList").redeem_code,
        //     trigger: "blur",
        //   },
        // ],
      },
      dateValue: '',
      options: [
        { label: this.$t('couponList.type0'), value: 0 },
        { label: this.$t('couponList.type1'), value: 1 },
        { label: this.$t('couponList.type3'), value: 2 },
        { label: this.$t('couponList.type2'), value: 3 },
      ],
    };
  },
  computed: {
    noId() {
      return this.$route.query.id === undefined;
    },
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t('btnTip').add
        : this.$t('btnTip').edit;
    },
  },
  watch: {
    dateValue() {
      if (this.dateValue === null) {
        this.ruleForm.start_time = '';
        this.ruleForm.end_time = '';
        return;
      }
      this.ruleForm.start_time =
        time.currentTime(this.dateValue[0]) + ' 00:00:00';
      this.ruleForm.end_time =
        time.currentTime(this.dateValue[1]) + ' 23:59:59';
    },
  },
  methods: {
    handleSetMember() {
      this.$router.push(`/couponManagement/couponList/edit/setmember?id=${this.id}`);
    },
    async submitForm(formName) {
      await this.$refs[formName].validate();
      if (this.id === undefined) {
        await addCoupon(this.ruleForm);
      } else {
        delete this.ruleForm.create_time;
        delete this.ruleForm.update_time;
        delete this.ruleForm.redeem_num;
        delete this.ruleForm.redeem_code;
        await editCoupon(this.ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await couponDetail(this.id);
      this.dateValue = [
        new Date(information.start_time),
        new Date(information.end_time),
      ];
      this.ruleForm = { ...information };
    },
  },
  async created() {
    if (this.id === undefined) return;
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}

.setMemberNum {
  margin-top: 6px;
  color:  #ACB0B3;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 185.714% */
}

.asterisk {
  display: inline-block;
  vertical-align: text-top;
  line-height: 1;
  position: relative;
  top: 5px;
}

.el-button--default {
  border-radius: 4px;
  background: #919398;

  color: #FFF;
  text-align: center;
}
</style>
